export class Parametrage {
    constructor(
        public id?: number,
        public rubrique?: string,
        public code?: string,
        public page?: string,
        public typeParam?: string,
        public objet?: string,
        public objetEn?: string,
        public libelle?: string,
        public libelleEn?: string,
        public date?: Date
    ) {
    }

    get libelleBoolean(): boolean {
        return this.libelle != null &&
            (typeof this.libelle === 'string' || this.libelle instanceof String) &&
            this.libelle.toLowerCase() == 'true';
    }

    set libelleBoolean(thebool: boolean) {
        this.libelle = thebool != null && thebool == true ? 'true' : 'false';
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/parametrage/parametrage.model.ts